module.exports = __webpack_public_path__ + "static/media/screen1.949c7530.png";